import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { UseUIBasicIconDirective } from '../../ui-components/atoms/icons/ui-basic.directive';
import { IconButtonDirective } from '../../ui-components/molecules/icon-button.directive';
import { LayoutActions } from '../store/layout.actions';
import { LayoutState } from '../store/layout.reducer';
import { selectIsRightPanelMaximized, selectIsRightPanelOpened } from '../store/layout.selectors';

@Component({
  selector: 'dmcom-right-panel',
  standalone: true,
  imports: [CommonModule, UseUIBasicIconDirective, IconButtonDirective],
  template: `
    <div
      class="absolute top-0 h-full z-30 w-[var(--right-panel-width)] bg-shades-white border-l border-gray-200 shadow-lg transition-all duration-600 ease-in-out"
      style="boxShadow: -4px 0 20px 0 rgba(0, 0, 0, 0.06);"
      [class.w-full]="isRightPanelMaximized()"
      [class.right-panel-position-closed]="!isRightPanelOpened()"
      [class.right-panel-position-opened]="isRightPanelOpened()"
    >
      <!-- Header -->
      <div class="absolute z-10 top-0 left-0 right-12 flex flex-col justify-end h-[var(--header-height)]">
        <div class="flex items-center  w-full justify-between bg-shades-white pt-20 px-20">
          <!-- Maximize/Minimize button -->
          <button
            dmcomIconButton
            [color]="'neutral'"
            variant="icon"
            size="lgsm"
            [attr.aria-label]="isRightPanelMaximized() ? 'Minimize panel' : 'Maximize panel'"
            (click)="toggleMaximized()"
          >
            <svg [dmcomUseUIBasicIcon]="isRightPanelMaximized() ? 'minimize' : 'maximize'"></svg>
          </button>

          <button dmcomIconButton [color]="'neutral'" variant="icon" size="lgmd" (click)="closePanel()">
            <svg dmcomUseUIBasicIcon="close"></svg>
          </button>
        </div>

        <div class="h-24 bg-gradient-fade-to-white"></div>
      </div>

      <!-- Content -->
      <div class="relative px-40 pt-94 pb-40 w-full overflow-y-auto h-full scrollable-component">
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class RightPanelComponent {
  private readonly store = inject<Store<LayoutState>>(Store);

  readonly isRightPanelOpened = this.store.selectSignal(selectIsRightPanelOpened);

  readonly isRightPanelMaximized = this.store.selectSignal(selectIsRightPanelMaximized);

  closePanel(): void {
    this.store.dispatch(LayoutActions.setRightPanelOpened({ isOpened: false }));
    this.store.dispatch(LayoutActions.setRightPanelMaximized({ isMaximized: false }));
  }

  toggleMaximized(): void {
    this.store.dispatch(
      LayoutActions.setRightPanelMaximized({
        isMaximized: !this.isRightPanelMaximized(),
      }),
    );
  }
}
